import { render, staticRenderFns } from "./CreateContactAction.vue?vue&type=template&id=1754026a&scoped=true"
import script from "./CreateContactAction.vue?vue&type=script&lang=js"
export * from "./CreateContactAction.vue?vue&type=script&lang=js"
import style0 from "./CreateContactAction.vue?vue&type=style&index=0&id=1754026a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754026a",
  null
  
)

export default component.exports